import { render, staticRenderFns } from "./BotaoCancelar.vue?vue&type=template&id=78e59d8e&scoped=true"
import script from "./BotaoCancelar.vue?vue&type=script&lang=js"
export * from "./BotaoCancelar.vue?vue&type=script&lang=js"
import style0 from "./BotaoCancelar.vue?vue&type=style&index=0&id=78e59d8e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e59d8e",
  null
  
)

export default component.exports